import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {SLIDESHOW_KEY} from "./Slideshow";

const MANIFEST_URL = "https://d381hui2s4gftp.cloudfront.net/wedding/media/manifest.json";

const parseHashIndex = () => {
    if (typeof window === "undefined") return null;
    const raw = window.location.hash.replace(/^#/, "");
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
};

const messageStyle = {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "#000",
    color: "#aaa",
    fontFamily: "system-ui, -apple-system, sans-serif",
};

export const PhotoGrid = () => {
    const {key} = useParams();
    const navigate = useNavigate();
    const [photos, setPhotos] = useState([]);
    const [error, setError] = useState(null);
    const scrollRef = useRef(null);
    const targetIndexRef = useRef(parseHashIndex());

    const keyMatches = key === SLIDESHOW_KEY;

    useEffect(() => {
        if (!keyMatches) return;
        let cancelled = false;
        fetch(MANIFEST_URL)
            .then(r => {
                if (!r.ok) throw new Error(`Manifest fetch failed: ${r.status}`);
                return r.json();
            })
            .then(data => !cancelled && setPhotos(data))
            .catch(err => !cancelled && setError(err.message));
        return () => { cancelled = true; };
    }, [keyMatches]);

    useEffect(() => {
        const target = targetIndexRef.current;
        if (target == null || photos.length === 0 || !scrollRef.current) return;
        const idx = ((target % photos.length) + photos.length) % photos.length;
        const tile = scrollRef.current.querySelector(`[data-tile-index="${idx}"]`);
        if (tile) {
            tile.scrollIntoView({behavior: "auto", block: "center"});
        }
        targetIndexRef.current = null;
    }, [photos.length]);

    if (!keyMatches) return <div style={messageStyle}>Not found.</div>;
    if (error) return <div style={{...messageStyle, color: "#f88"}}>Failed to load photos: {error}</div>;
    if (photos.length === 0) return <div style={messageStyle}>Loading {photos.length || 1435} photos…</div>;

    return (
        <div ref={scrollRef} style={{
            height: "100vh",
            width: "100vw",
            overflowY: "auto",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch",
            background: "#000",
            padding: 4,
            boxSizing: "border-box",
        }}>
            <div
                style={{
                    columnWidth: 240,
                    columnGap: 4,
                }}
            >
                {photos.map((p, idx) => (
                    <button
                        key={p.filename}
                        data-tile-index={idx}
                        onClick={() => navigate(`/slideshow/${SLIDESHOW_KEY}#${idx}`)}
                        className="photo-grid-tile"
                        aria-label={`Open photo ${idx + 1} of ${photos.length}`}
                        style={{
                            display: "block",
                            width: "100%",
                            padding: 0,
                            margin: 0,
                            marginBottom: 4,
                            border: 0,
                            background: "transparent",
                            cursor: "pointer",
                            breakInside: "avoid",
                            overflow: "hidden",
                            borderRadius: 2,
                        }}
                    >
                        <img
                            src={p.src}
                            alt={`Photo by ${p.firstName} ${p.lastName}`}
                            loading="lazy"
                            decoding="async"
                            width={p.width}
                            height={p.height}
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                            }}
                            draggable={false}
                        />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default PhotoGrid;
